import React from 'react';
import { Link } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const TitleContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2)
}));

export const ActionsContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  height: 'fit-content',
  paddingLeft: theme.spacing(4)
}));

export const Content = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));

export const ReachOutToContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1)
}));

export const TaskTitleLabel = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1)
}));

export const CommunicationActionsContainer = styled('div')({
  display: 'flex'
});

export const EmailAction = styled(({ hasEmail: _, ...other }) => <Link {...other} />)(
  ({ hasEmail }) => ({
    pointerEvents: hasEmail ? 'auto' : 'none',
    cursor: hasEmail ? 'pointer' : 'default'
  })
);
